import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'xspectre_theme';

export function useThemeToggle() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'light') return false;
      if (saved === 'dark') return true;
      return true;
    } catch (_) {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, isDarkMode ? 'dark' : 'light');
    } catch (_) { /* ignore */ }
  }, [isDarkMode]);

  const toggleDarkMode = useCallback(() => setIsDarkMode((d) => !d), []);

  return { isDarkMode, setIsDarkMode, toggleDarkMode };
}
